export default __webpack_public_path__ + "locales/bg/DeleteThirdPartyDialog.json?hash=0d858cb26074bdf272006a81c12679b8";